export default "__VITE_ASSET__DajJ47_T__"